export const insuranceFormulaContextCode = 'INSURANCE';
export const MinDecimalPrecision = -4;
export const MaxDecimalPrecision = 6;
